module.exports = __webpack_public_path__ + "img/25_68.64a219d2.png";